import React from 'react'
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import UserListContainer from '../../containers/usermenumng/UserListContainer';

const UserMenuMngPage = () => {
  return (
    <>
    <BreadcrumbsContainer title="공통관리/사원별 메뉴관리/사원별 메뉴 리스트" icon="menu"/>
    
    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', }}>
        <Box sx={{ width: "360px",mr:1 }}> <UserListContainer /></Box>
        <Box sx={{ flexGrow: 1 }}><Outlet /></Box>
    </Box>
</>
  )
}

export default UserMenuMngPage